import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

import { GetMarketCollectionsDocument } from 'hooks/useQueries'

type CollectionsIndexSsr = {
  collections?: unknown
}

type SeedMarket = {
  id?: string | number
}

// Variables must match the consumer (CollectionsIndex/index.tsx) exactly so the
// seed shares its Apollo cache key. writeQuery is synchronous — safe in
// mini_racer SSR.
const seedCollectionsIndex = (
  client: ApolloClient<NormalizedCacheObject>,
  ssr: CollectionsIndexSsr | undefined,
  market: SeedMarket | undefined,
): void => {
  if (!ssr?.collections) return

  const marketId = market?.id?.toString()
  if (!marketId) return

  try {
    client.writeQuery({
      query: GetMarketCollectionsDocument,
      variables: { marketId },
      data: ssr.collections,
    })
  } catch {
    // Best-effort: a malformed payload must not break the render.
  }
}

export default seedCollectionsIndex
